module.exports = __webpack_public_path__ + "img/whatsapp_icon.4e0781c0.svg";